import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import Navigation from './components/Navigation';
import LoadingScreen from './components/LoadingScreen';
import './App.css';
import { I18nProvider } from './i18n';
import { CMSProvider } from './contexts/CMSContext';

const About = React.lazy(() => import('./components/About'));
const Music = React.lazy(() => import('./components/Music'));
const Services = React.lazy(() => import('./components/Services'));
const Credits = React.lazy(() => import('./components/Credits'));
const Contact = React.lazy(() => import('./components/Contact'));
const Footer = React.lazy(() => import('./components/Footer'));
const BeatsGallery = React.lazy(() => import('./components/BeatsGallery'));

function App() {
  return (
    <I18nProvider>
      <CMSProvider>
        <LoadingScreen />
        <Navigation />
        <div className="App">

          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={
                <main className="main-content">
                  <Hero />
                  <Ticker />
                  <Suspense fallback={null}>
                    <Music />
                  </Suspense>
                  <Suspense fallback={null}>
                    <About />
                  </Suspense>
                  <Suspense fallback={null}>
                    <Services />
                  </Suspense>
                  <Suspense fallback={null}>
                    <Credits />
                  </Suspense>
                  <Suspense fallback={null}>
                    <Contact />
                  </Suspense>
                </main>
              } />
              <Route path="/beats" element={
                <Suspense fallback={null}>
                  <BeatsGallery />
                </Suspense>
              } />
            </Routes>
            <Footer />
          </Suspense>
        </div>
      </CMSProvider>
    </I18nProvider>
  );
}

export default App;
